import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import st from "@/styles/Modals.module.scss";
import {useAtom} from "jotai/index";
import {schedule_modal_content} from "@/atoms/modals.ts";
import {useTranslation} from "react-i18next";


const ScheduleModal = () => {
    const [schedule, set_schedule] = useAtom(schedule_modal_content)
    const {t} = useTranslation()
    
    
    return (
        <ModalLayout
            className={st.schedule_modal}
            // open={true}
            open={Boolean(schedule.length)}
            innerClassName={st.schedule_modal_inner}
            on_close_state={() => {
                // setOpen(false)
                set_schedule("")
            }}
        >
            
            <>
                <h3>
                    {t("reimbursement_schedule")}
                </h3>
                
                <div dangerouslySetInnerHTML={{__html:schedule}} />
            </>
        
        </ModalLayout>
    )
}

export default ScheduleModal